import { useEffect, useState } from 'react';

export function NumericField({ label, value, unit = 'mm', min = -100000, max = 100000, step = 1, onCommit }: { label: string; value: number; unit?: string; min?: number; max?: number; step?: number; onCommit: (value: number) => void }) {
  const [draft, setDraft] = useState(String(Math.round(value * 1000) / 1000));
  useEffect(() => setDraft(String(Math.round(value * 1000) / 1000)), [value]);
  const commit = () => {
    const parsed = Number(draft.replace(',', '.'));
    if (Number.isFinite(parsed)) onCommit(Math.min(max, Math.max(min, Math.round(parsed / step) * step)));
    else setDraft(String(value));
  };
  return <label className="property-control"><span className="property-label">{label}</span><span className="numeric-control"><input inputMode="decimal" value={draft} onChange={(event) => setDraft(event.target.value)} onBlur={commit} onKeyDown={(event) => { if (event.key === 'Enter') event.currentTarget.blur(); if (event.key === 'Escape') { setDraft(String(value)); event.currentTarget.blur(); } }} /><span>{unit}</span></span></label>;
}
